<template>
  <navBar current="news"></navBar>
  <main class="news flex-column align-center justify-center">
    <loading v-if="loading" />

    <div class="news-wrapper">
      <figure
        v-for="(item, index) of newsList"
        :key="index"
        class="news-item pointer"
        @click="toNewsDetail(item)"
      >
        <van-image
          draggable="false"
          fit="cover"
          class="full-parent"
          :src="
            index == 0 ? item.titleImg : $filters.formatImage(item.titleImg)
          "
        />
        <figcaption class="title">{{ item.title }}</figcaption>
      </figure>
    </div>
  </main>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import navBar from "../../components/nav-bar/nav-bar.vue";
import { api } from "../../assets/utils/config";
import { post, PostConfig } from "@/assets/utils/common";

export default defineComponent({
  components: { navBar },

  data() {
    return {
      loading: false,
      newsList: [],
    };
  },

  mounted() {
    this.getShowWebsiteKnowinfo();
  },

  methods: {
    getShowWebsiteKnowinfo() {
      let config: PostConfig = {
        url: api.getShowWebsiteKnowinfo,
      };
      this.loading = true;
      post(config).then((res) => {
        this.loading = false;
        if (res.status == 0) {
          this.newsList = res.data.slice(0, 7);
        }
      });
    },

    toNewsDetail(item: any) {
      if (item.link) window.open(item.link);
    },
  },
});
</script>

<style lang="less" scope src="./news.less"></style>